import { createStyles, makeStyles } from '@material-ui/core';

export default makeStyles((theme) => createStyles({
  attached: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
}));
